import { render, staticRenderFns } from "./EventRegistrationComplete.vue?vue&type=template&id=378e911d&"
import script from "./EventRegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports